import { useCallback } from "react";
import PropTypes from "prop-types";
import is from "@sindresorhus/is";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

import Cardiogram from "../../../icons/Cardiogram";
import ChevronRight from "../../../icons/ChevronRight";
import Diagnostic from "../../../icons/Diagnostic";
import HairTools from "../../../icons/HairTools";
import Pharmacy from "../../../icons/Pharmacy";

const PostPreview = props => {
  const { barColor, date, icon, onClick, sx, text, title, ...others } = props;
  const theme = useTheme();

  const bgcolor = is.string(barColor) ? barColor : theme.palette.text.primary;

  const onClick_ = useCallback(() => {
    if (is.function(onClick)) onClick();
  }, [onClick]);

  return (
    <Box
      onClick={onClick_}
      {...others}
      sx={{
        display: "flex",
        "&:hover": {
          color: theme.palette.primary.main,
          cursor: "pointer",
          borderRadius: 1,
          background: "rgba(255,255,255,0.03)",
          transform: "scale(1.02)",
          transition: "transform 0.4s"
        },
        ...sx
      }}
    >
      <>
        <Box sx={{ color: theme.palette.primary.main }}>
          {icon === "Cardiogram" && <Cardiogram fontSize="small" />}
          {icon === "ChevronRight" && <ChevronRight fontSize="small" />}
          {icon === "Diagnostic" && <Diagnostic fontSize="small" />}
          {icon === "HairTools" && <HairTools fontSize="small" />}
          {icon === "Pharmacy" && <Pharmacy fontSize="small" />}
        </Box>
        <Box sx={{ bgcolor: bgcolor, pl: 1, mr: 1 }} />
        <Box sx={{ flex: 1 }}>
          <Typography component="div" variant="body2" sx={{ color: theme.palette.primary.main, textTransform: "uppercase" }}>
            {title}
          </Typography>
          {is.string(date) && (
            <Typography component="div" variant="caption" sx={{ color: theme.palette.text.secondary, pb: 0.5 }}>
              {date}
            </Typography>
          )}
          <Typography component="div" sx={{ color: theme.palette.text.primary }}>
            {text}
          </Typography>
        </Box>
      </>
    </Box>
  );
};

PostPreview.defaultProps = {
  barColor: null,
  date: null,
  icon: "ChevronRight",
  onClick: null,
  sx: null,
  text: "text",
  title: "title"
};

PostPreview.propTypes = {
  barColor: PropTypes.string,
  date: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  sx: PropTypes.object,
  text: PropTypes.string,
  title: PropTypes.string
};

export default PostPreview;
